import {useNavigate} from "react-router-dom";
import {CaretRightIcon} from "@phosphor-icons/react";
import NumberFlow, {continuous} from "@number-flow/react";
import {useData} from "context/data.context";
import {CURRENCY_SHORT, LOCALE} from "utilities/global.variables";

const FutureworthCard = () => {
  const navigate = useNavigate();
  const { networthProjected } = useData();

  return (
    <div
      className="card r4-3 flex col space pointer"
      onClick={() => {
        navigate("/futureworth");
        window.scrollTo(0, 0);
      }}>
      <div className="flex row space">
        <div className="">
          <p className="large">Futureworth</p>
                  <p className="regular o60">in {networthProjected.years} years</p>

        </div>
        <p className="large">
          <CaretRightIcon />
        </p>
      </div>

      <div>
        {" "}
        <NumberFlow className="number xxxlarge" plugins={[continuous]} locales={LOCALE} format={CURRENCY_SHORT} value={networthProjected.total} />
      </div>
    </div>
  );
};

export default FutureworthCard;
